import React from 'react';

const FormErrorMessage = (props) => {
    return <div className="error-message">{props.children}</div>;
};

export default FormErrorMessage;
